import { AdminVacancyComplaints } from '@cookspace-shared-contracts/core';
import { z } from 'zod';

/**
 * Схемы для admin-эндпоинтов /vacancy-complaints/* (фича staff-hiring Ф2,
 * пост-модерация жалоб на вакансии №14/№19). Контракты живут в
 * shared-contracts (namespace `AdminVacancyComplaints`, 27.0.0) — здесь
 * реэкспортируем их и собираем response-обёртки для строгого парсинга
 * ответов admin-backend через safeParse. Эталон — `cafeApplicationsSchemas`.
 */

export const VacancyComplaintListItemSchema =
    AdminVacancyComplaints.VacancyComplaintListItemSchema;
export type VacancyComplaintListItem = AdminVacancyComplaints.VacancyComplaintListItem;

export const VacancyComplaintDetailSchema = AdminVacancyComplaints.VacancyComplaintDetailSchema;
export type VacancyComplaintDetail = AdminVacancyComplaints.VacancyComplaintDetail;

export const VacancyComplaintAuthorSchema = AdminVacancyComplaints.VacancyComplaintAuthorSchema;
export type VacancyComplaintAuthor = AdminVacancyComplaints.VacancyComplaintAuthor;

export const ComplaintVacancyFullSchema = AdminVacancyComplaints.ComplaintVacancyFullSchema;
export type ComplaintVacancyFull = AdminVacancyComplaints.ComplaintVacancyFull;

export const ComplaintVacancyBranchSchema = AdminVacancyComplaints.ComplaintVacancyBranchSchema;
export type ComplaintVacancyBranch = AdminVacancyComplaints.ComplaintVacancyBranch;

export const OtherVacancyComplaintRefSchema =
    AdminVacancyComplaints.OtherVacancyComplaintRefSchema;
export type OtherVacancyComplaintRef = AdminVacancyComplaints.OtherVacancyComplaintRef;

/**
 * Ответ списка `GET /vacancy-complaints` — `{ items, total }`.
 */
export const ListVacancyComplaintsResponseSchema =
    AdminVacancyComplaints.ListVacancyComplaintsResponseSchema;
export type ListVacancyComplaintsResponse =
    AdminVacancyComplaints.ListVacancyComplaintsResponse;

/**
 * Ответ детали `GET /vacancy-complaints/:id` — `{ complaint, vacancy,
 * otherComplaintsCount, otherComplaints }`.
 */
export const GetVacancyComplaintResponseSchema =
    AdminVacancyComplaints.GetVacancyComplaintResponseSchema;
export type GetVacancyComplaintResponse = AdminVacancyComplaints.GetVacancyComplaintResponse;

export const HideVacancyByModeratorRequestSchema =
    AdminVacancyComplaints.HideVacancyByModeratorRequestSchema;
export type HideVacancyByModeratorRequest =
    AdminVacancyComplaints.HideVacancyByModeratorRequest;

export const HideVacancyByModeratorResponseSchema =
    AdminVacancyComplaints.HideVacancyByModeratorResponseSchema;
export type HideVacancyByModeratorResponse =
    AdminVacancyComplaints.HideVacancyByModeratorResponse;

export const DismissVacancyComplaintResponseSchema =
    AdminVacancyComplaints.DismissVacancyComplaintResponseSchema;
export type DismissVacancyComplaintResponse =
    AdminVacancyComplaints.DismissVacancyComplaintResponse;

/**
 * Фильтры списка жалоб для admin SPA. Соответствует
 * `ListVacancyComplaintsRequestSchema` (status опц. + пагинация), но без
 * `.strict()` — query собирается api-слоем.
 */
export const ListVacancyComplaintsFiltersSchema = z.object({
    status: VacancyComplaintListItemSchema.shape.status.optional(),
    limit: z.number().int().min(1).max(100).optional(),
    offset: z.number().int().min(0).optional()
});

export type ListVacancyComplaintsFilters = z.infer<typeof ListVacancyComplaintsFiltersSchema>;
